import { render, staticRenderFns } from "./CardProjectWages.vue?vue&type=template&id=338426e7&scoped=true&"
import script from "./CardProjectWages.vue?vue&type=script&lang=js&"
export * from "./CardProjectWages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338426e7",
  null
  
)

export default component.exports